import { EffectsMapObject } from "dva";

export const CoreEffects: EffectsMapObject = {};
